import React, { useState } from 'react'
import Select from 'react-select'
import { InputNumber } from 'rsuite'

import {
  ruleBidActionList,
  RULE_BID_ACTION_DEC,
  RULE_BID_ACTION_PAUSE,
} from '../../utils/defaultValues'

const BidRuleSection = ({ isReadOnly, action, value,
  onActionChange, onValueChange, onClear }) => {
  const [error, setError] = useState('')

  const validate = (newAction, newValue) => {
    setError('')
    if (!newAction || newAction.value === RULE_BID_ACTION_PAUSE) {
      return
    }

    if (newAction.value === RULE_BID_ACTION_DEC) {
      if (!(!isNaN(parseFloat(newValue))
        && parseFloat(newValue) > 0
        && parseFloat(newValue) < 100)) {
        setError('The change must be greater than 0 and less than 100.')
      }
    } else {
      if (!(!isNaN(parseFloat(newValue))
        && parseFloat(newValue) > 0)) {
        setError('The change must be greater than 0.')
      }
    }
  }

  const handleActionChange = (newAction) => {
    validate(newAction, value)
    onActionChange(newAction)
  }

  const handleValueChange = (newValue) => {
    validate(action, newValue)
    onValueChange(newValue)
  }

  return (
    <div className="rule-sub-section">
      <div className="sub-section-name">
        Bid
      </div>
      <div className="sub-section-body">
        <div className="rule-settings-container">
          <Select
            classNamePrefix="rule-select"
            options={ruleBidActionList}
            placeholder="Select action"
            isDisabled={isReadOnly}
            value={action}
            onChange={handleActionChange}
          />
          {
            action && action.value !== RULE_BID_ACTION_PAUSE && (
              <InputNumber
                className="value-input"
                min={0}
                placeholder="Set value"
                postfix="%"
                disabled={isReadOnly}
                value={value}
                onChange={handleValueChange}
              />
            )
          }
        </div>
        {
          action !== null && !isReadOnly && (
            <span
              className="clear-link"
              onClick={onClear}
            >
              Clear
            </span>
          )
        }
      </div>
      {
        error !== '' && (
          <div className="sub-section-error">
            { error }
          </div>
        )
      }
    </div>
  )
}

export default BidRuleSection
